import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A flight",
  "description": "",
  "published": "2010-10-14T00:00:00.000Z",
  "redirect_from": ["/blog/a-flight/swizec/1468"],
  "categories": "Jet lag, San Francisco, Tea, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    {
      /* p.p1 {margin: 0.0px 0.0px 0.0px 0.0px; font: 13.0px Arial} p.p2 {margin: 0.0px 0.0px 0.0px 0.0px; font: 13.0px Arial; min-height: 15.0px} */
    }
    <p>{`It is 8 o'clock airplane time and I just got caught red handed making some unauthorized tea.`}</p>
    <p>{`It's a bit boring up here, I've already watched two movies, did some actual work, read about 70 pages of Ulysses, transfered a bunxh of music to the iPad, drank hundreds of cups of water, three cups of tea, had fi ve walks, ten bathroom breaks, and ate two chocolate bars.`}</p>
    <p>{`All @skatey has done is sleep. Ha!`}</p>
    <p>{`We find out who's better at evading jet lag tomorrow. He'll be getting lots of sleep, while I'll be arriving at San Francisco quite sleepy, but after an 8 hour sleep should wake up in the correct timezone.`}</p>
    <p>{`Anywho, I was back in the rear galley. Just sort of loitering. And I figured the pots of hot water and adjacent baggie of tea were just as self service as the trays of water and juice and the buckets of chocolate.`}</p>
    <p>{`Just as I proceeded to help myself a very cross flight attendant told me I can't just do that. Something about those specific baggies of yummy tea being for the big pot ... then she gave me some el cheapo tea in a small baggy.`}</p>
    <p>{`Also, her "good god man, stop being an idiot and let me do my job, i hatebeing here because of assholes like you" look was sooper cute.`}</p>
    <p>{`Another thing I noticed in the last eight hours trapped in this tiny chair and surrounded by incredibly dry air is that laptops are the most perfectly impractical device for economy flying.`}</p>
    <p>{`iPads fare much better, but lack the ability to ... work well with dried out fingers. Stupid fake climate!`}</p>
    <p>{`It's a mystery how I felt like doing a bit of creative writing when I started out wr iting this post, but ended up with this rather monotonous drivel. Maybe I should just stick to programming.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=fc430327-b2c2-4590-9a0a-3286e69b92d0",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      